import { memo } from 'react';

import sanitizeHtml from 'sanitize-html';

interface IProps {
	content: string;
}

function RichTextContent({ content }: IProps) {
	const sanitizedContent = sanitizeHtml(content, {
		allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'span']),
		allowedAttributes: {
			'*': [
				'style',
				'src',
				'alt',
				'srcset',
				'sizes',
				'width',
				'height',
				'data-*',
			],
		},
		// transformTags: {
		// 	'ol': sanitizeHtml.simpleTransform('ul', {class: 'foo'}),
		//   }
	});

	return (
		<div
			className="prose sanitized-content w-full min-w-full [&_img]:!mx-auto [&_figure]:!w-full [&_li]:marker:text-bittersweet" // Add Tailwind's `prose` class to style the content
			dangerouslySetInnerHTML={{ __html: sanitizedContent }}
		/>
	);
}

export default memo(RichTextContent);
